module.exports = __webpack_public_path__ + "static/collapsedmeta-4c2a96bb8dfbafade898950909fcc9b6.png";